export default [
  {
    path: 'overview',
    name: 'VueJS Overview',
    description: 'Tutorials that will make you a better VueJS developer.',
    component: () => import(/* webpackChunkName: "tutorial-overview" */ '../views/Overview.vue'),
    meta: {
    },
  },
  {
    path: 'props',
    name: 'Props Tutorial',
    component: () => import(/* webpackChunkName: "tutorial-props" */ '../views/Props/index.vue'),
    meta: {
      description: 'How do Props work and why they are important?',
      level: "beginner",
      version: 1.0,
      authors : ["Zane H."],
      tech : ["VueJS"],
    },
  },
  {
    path: 'computed',
    name: 'Computed Tutorial (Karthic)',
    component: () => import(/* webpackChunkName: "tutorial-computed" */ '../views/Computed/index.vue'),
    meta: {
      description: 'Understanding Computed Variables?',
      level: "beginner",
      version: 0,
      authors : ["Karthic S."],
      tech : ["VueJS"],
    },
  },
  {
    path: 'watchers',
    name: 'Watcher Tutorial',
    component: () => import(/* webpackChunkName: "tutorial-watcher" */ '../views/Watchers/index.vue'),
    meta: {
      description: 'What is a watcher and how can you use it?',
      level: "beginner",
      version: 1.0,
      authors : ["Andrii B.","Karthic S."],
      tech : ["VueJS"],

    },
  },
  {
    path: 'page-layouts',
    name: 'Page Layouts Tutorial',
    component: () => import(/* webpackChunkName: "tutorial-page-layouts" */ '../views/PageLayouts/index.vue'),
    meta: {
      description: 'Using Custom Page Layouts',
      level: "beginner",
      version: 1.0,
      authors: ["Andrii B."],
      tech: ["VueJS"],
    }
  },  
  {
    path: 'emit',
    name: 'Emitting Events Tutorial',
    component: () => import( /* webpackChunkName: "tutorial-emit" */ '../views/Emit/index.vue'),
    meta: {
      description: 'What is an emit and how can I use it?',
      level: "beginner",
      version: 1.0,
      authors: ["Karthic S."],
      tech: ["VueJS"],
    },
  },
  {
    path: 'popup-notifier',
    name: 'Popup Notifier Tutorial',
    component: () => import( /* webpackChunkName: "tutorial-emit" */ '../views/PopupNotifier/index.vue'),
    meta: {
      description: 'Why do we need Popup Notifier?',
      level: "beginner",
      version: 1.0,
      authors: ["Karthic S."],
      tech: ["VueJS"],
    },
  },
  {
    path: 'environment-variables',
    name: 'Environmental Variables Tutorial',
    component: () => import( /* webpackChunkName: "tutorial-emit" */ '../views/EnvironmentVars/index.vue'),
    meta: {
      description: 'How to implement Environment Variables',
      level: "intermediate",
      version: 1.0,
      authors: ["Zane H."],
      tech: ["VueJS","Azure"],
    },
  },
  {
    path: 'custom-components',
    name: 'Custom Components Tutorial',
    component: () => import(/* webpackChunkName: "tutorial-custom-components" */ '../views/CustomComponents/index.vue'),
    meta: {
      description: 'Creating your own custom components.',
      level: "intermediate",
      version: 0,
      authors : [],
      tech : ["VueJS"],
    },
  },
  {
    path: 'vmodel',
    name: 'VModel Tutorial',
    component: () => import(/* webpackChunkName: "tutorial-vmodel" */ '../views/VModel/index.vue'),
    meta: {
      description: 'Exploring the v-model convention in Vue 2.x',
      level: "intermediate",
      version: 1.0,
      authors : ["Zane H."],
      tech : ["VueJS"],
    },
  },
  {
    path: 'logging',
    name: 'Logging Tutorial',
    component: () => import(/* webpackChunkName: "tutorial-logging" */ '../views/Logging/index.vue'),
    meta: {
      description: "Exploring logging using Microsoft's Application Insights",
      level: "intermediate",
      version: 0.1,
      authors : ["Zane H."],
      tech : ["Azure"],
    },
  },
  {
    path: 'mixins',
    name: 'Mixins Tutorial',
    component: () => import(/* webpackChunkName: "tutorial-vmodel" */ '../views/Mixins/index.vue'),
    meta: {
      description: 'Using and layering mixins for code reusability',
      level: "intermediate",
      version: 1.0,
      authors : ["Karthic S."], 
      tech : ["VueJS"],
    },
  },
  {
    path: 'slots',
    name: 'Slots Tutorial',
    component: () => import(/* webpackChunkName: "tutorial-slots" */ '../views/Slots/index.vue'),
    meta: {
      description: 'How do Slots work and why they are important?',
      level: "intermediate",
      version: 1.0,
      authors : ["Andrii B.", "Karthic S."],
      tech : ["VueJS"],
    },
  },
  {
    path: 'vue-router',
    name: 'Vue Router Tutorial',
    component: () => import(/* webpackChunkName: "tutorial-vue-router" */ '../views/VueRouter/index.vue'),
    meta: {
      description: 'Some basic configuration for the Vue Router.',
      level: "advanced",
      version: 0.1,
      authors : ["Zane H."],
      tech : ["VueJS"],
    },
  },
  {
    path: 'vue-store',
    name: 'Vue Store Tutorial',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/VueStore/index.vue'),
    meta: {
      description: 'Some basic configuration for the Vue Store.',
      level: "advanced",
      version: 1,
      authors : ["Karthic S."],
      tech : ["VueJS"],
    },
  },
  {
    path: 'oauth-tutorial',
    name: 'OAUTH Interactive Tutorial',
    component: () => import(/* webpackChunkName: "my-app-overview" */ '../views/OAUTH/'),
    meta : {
      description: 'Configuring your OAUTH instance',
      level: "advanced",
      version: 1,
      authors : ["Zane H."],
      tech : ["VueJS","Azure"],
    },
  },
]

/*
npom run 
.sync modifier

array functions:
    .filter .map, etc

custom components

extending components

testing

mixins

vuetify

Creating Pages

The breakdown of an app folder

code chunking

swagger file

*/